import { useEffect, useState } from "react";
import { Alert, Box, Button, Paper, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

const CompleteFormUploaderRegistration = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const validateInvitation = async () => {
      if (!token) {
        setError("This invitation is invalid or has expired.");
        setLoading(false);
        return;
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/nocApi/form-dig-users/invitation`,
          { token },
        );
        setEmail(response.data.data.email);
      } catch (requestError) {
        setError(
          requestError?.response?.data?.message ||
            "This invitation is invalid or has expired.",
        );
      } finally {
        setLoading(false);
      }
    };
    validateInvitation();
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must contain at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/form-dig-users/complete-registration`,
        { token, password },
      );
      setComplete(true);
    } catch (requestError) {
      setError(
        requestError?.response?.data?.message || "Registration could not be completed.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        backgroundColor: "#edf1f5",
        p: 2,
      }}
    >
      <Paper sx={{ width: "100%", maxWidth: 480, p: { xs: 3, sm: 5 } }}>
        <Box
          component="img"
          src="/img/logos/logo_main.png"
          alt="Permit Rockstar"
          sx={{ width: 220, maxWidth: "100%", display: "block", mx: "auto", mb: 3 }}
        />
        <Typography variant="h4" textAlign="center" gutterBottom>
          Create your password
        </Typography>
        {loading ? (
          <Typography textAlign="center">Validating invitation…</Typography>
        ) : complete ? (
          <>
            <Alert severity="success" sx={{ my: 2 }}>
              Your password has been created. You can now sign in.
            </Alert>
            <Button fullWidth variant="contained" onClick={() => navigate("/login")}>
              Continue to sign in
            </Button>
          </>
        ) : error && !email ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit}>
            <TextField fullWidth label="Email" value={email} disabled sx={{ mt: 2 }} />
            <TextField
              fullWidth
              required
              type="password"
              label="Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              sx={{ mt: 2 }}
            />
            <TextField
              fullWidth
              required
              type="password"
              label="Confirm password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              sx={{ mt: 2 }}
            />
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              loading={submitting}
              sx={{ mt: 3 }}
            >
              Create password
            </LoadingButton>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default CompleteFormUploaderRegistration;